class DeleteModalController {
  $onInit = () => {
    const ctrl = this;
    this.item = this.resolve.item;
  }

  submit() {
    this.close({ $value: this.item.id });
  }

  cancel() {
    this.dismiss({ $value: 'cancel' });
  }
}

angular
  .module('pis-common.module')
  .controller('DeleteModalController', DeleteModalController);
